import * as React from 'react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AppNavbar from '../components/AppNavbar';
import Header from '../components/Header';
import SideMenu from '../components/SideMenu';
import AppTheme from '../shared-theme/AppTheme';
import axiosInstance from '../utils/axiosInstance';

export default function UsersPage(props) {
  const [state, setState] = useState({ loading: true, users: [] });
  const partnerProfile = useSelector((current) => current.auth.partnerProfile);
  useEffect(() => {
    let active = true;
    async function load() {
      try {
        const unitsResponse = await axiosInstance.get('/partners/user/business-units');
        const units = unitsResponse.data?.business_units || [];
        const results = await Promise.all(units.map(async (unit) => {
          const response = await axiosInstance.get(`/partners/user/business-units/${encodeURIComponent(unit.business_unit_id)}/users`);
          return (response.data?.users || []).filter((user) => user.has_access !== false).map((user) => ({
            ...user,
            business_unit_id: unit.business_unit_id,
            business_unit_name: unit.display_name || unit.business_unit_code || unit.business_unit_id,
          }));
        }));
        if (active) setState({ loading: false, users: results.flat() });
      } catch (_error) { if (active) setState({ loading: false, users: [] }); }
    }
    load();
    return () => { active = false; };
  }, [partnerProfile]);
  return <AppTheme {...props}><Box sx={{ display: 'flex' }}><SideMenu /><AppNavbar /><Box component="main" sx={{ flexGrow: 1, p: 3 }}>
    <Header breadcrumbItems={[{ label: 'AMX xConsole', href: '/' }, { label: 'Users' }]} />
    <Typography variant="h4" sx={{ fontWeight: 800, mb: 3 }}>Users</Typography>
    {state.loading ? <CircularProgress /> : state.users.length ? <Grid container spacing={2}>{state.users.map((user, index) => <Grid item xs={12} sm={6} md={4} key={`${user.cognito_sub}-${user.business_unit_id}-${index}`}><Card variant="outlined"><CardContent><Stack spacing={0.75}><Typography variant="h6" sx={{ fontWeight: 800 }}>{user.full_name || user.email || user.cognito_sub}</Typography><Typography variant="body2" color="text.secondary">{user.business_unit_name}</Typography></Stack></CardContent></Card></Grid>)}</Grid> : <Typography color="text.secondary">No users are associated with your accessible Business Units.</Typography>}
  </Box></Box></AppTheme>;
}
